//const API_BASE_URL = 'http://172.20.10.6:5000';
const API_BASE_URL = 'https://app.tradebookcrm.com';
// Stripe publishable key - safe to be in frontend code
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51T9VPY8qsdVocXDl6rXsn6q3m54fMFELovyToigU29WLjfSYTsBl3KhqIK6Ts7eiO8Y2E1OJHuSTteHLqnwm8W4x00PNKki20G';
export default API_BASE_URL;